module.exports = {
  replaceTplImagePath(str) {
    let content = str
    content = content.replace(/"http:\/\/img.gohappy\.com\.tw\/tpl/ig, '"https://img.shopping.friday.tw/tpl')
    content = content.replace(/("\/tpl)/ig, '"https://img.shopping.friday.tw/tpl')
    return content
  },
  replaceWidthAndHeight(str) {
    let content = str
    content = content.replace(/height:\s?\d+px;?/ig, '')
    content = content.replace(/(width):\s?\d+px;?/ig, 'width:100%;')
    content = content.replace(/(height="(\d+)")/ig, '')
    content = content.replace(/(width="(\d+)")/ig, 'width="100%"')
    return content
  },
  replaceContentTagStyle(str) {
    let content = str
    content = content.replace(/(style="([\d\w;:-]+)")/ig, '')
    return content
  }
}